import React from "react";
import NavBar from "../NavBar";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import axios from 'axios'
import CircularProgress from '@material-ui/core/CircularProgress';
import './accountStyle.css'
import InviteUser from "../modals/InviteUser";
import Confirmation from "../modals/confirmation";

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Modal } from "@material-ui/core";

// make to call to get user from redux or atom

const PlanLookup = {
    '1': { title: "Small", Description: "Add up to 3 users" },
    '2': { title: "Medium", Description: "Add up to 5 users" },
    '3': { title: "Large", Description: "Add up to 10 users" },
}

export default class Account extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            markers: [],
            user: props.user,
            people: []
        };
    }

    componentDidMount = async () => {
        // api to get user
        const { data } = await axios.get(`/api/accountsPage/${4}`)
        if (data && data.message === "No token provided") {
            window.location = '/login'
        } else {
            const { userInfo, ClientInfo, allUsers } = data
            this.setState({
                people: allUsers.recordset,
                ClientInfo: ClientInfo.recordset,
                userInfo: userInfo.recordset
            })
        }

    }

    changeValue = (e) => {
        e.preventDefault();
        const value = e.target.value
        const name = e.target.name
        //confirm password
        this.setState({
            [name]: value
        })
    }

    submitForm = (form) => {
        console.log(form)
        var people = this.state.people
        people.push({
            FirstName: this.state.first,
            LastName: this.state.last,
            IsActive: false,
            LoginID: this.state.Email,
            RoleID: this.state.RoleID,
            UserLevel: this.state.UserLevel
        })
        console.log(people)
        this.setState({
            InvitingUser: false,
            form: form,
            people: people
        })
    }




    render() {
        return (
            <div style={{ overflowX: 'hidden', height: '100vh', background: 'white' }}>
                {/* {this.state.InvitingUser ?
                    <Modal
                        open={this.state.InvitingUser}
                        onClose={() => this.setState({ InvitingUser: true })}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                    >
                       "div"
                    </Modal>
                    : null} */}
                <NavBar isAccountScreen={true} />
                {/* {this.state.InvitingUser && 
                <InviteUser
                    deleteMarker={() => this.setState({InvitingUser: false})}
                    submitForm={this.submitForm}
                />} */}

                <div style={{ margin: '45px 20vw 0px 20vw', padding: '30px' }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h1 style={{ borderBottom: '1px solid black', width: '100%' }}>Account</h1>
                    </div>
                    <div className="cardContainer">
                        <div>
                            <h2 className="userCard">User Info</h2>
                            <Card className="cardStyle">
                                {this.state.userInfo ? <div>
                                    <CardContent>
                                        <div>
                                            <div>First Name: <b className='bolder'>{this.state.userInfo[0].FirstName}</b></div>
                                            <div>Last Name: <b className='bolder'>{this.state.userInfo[0].LastName}</b></div>
                                            <div>Email: <b className='bolder'>{this.state.user.user.email}</b></div>
                                            <div>Department: <b className='bolder'>{this.state.userInfo[0].Department}</b></div>
                                            <div>Title: <b className='bolder'>{this.state.userInfo[0].Title}</b></div>
                                            <div>RoleID: <b className='bolder'>{this.state.userInfo[0].RoleID}</b></div>
                                            <div style={{ margin: "24px 0px" }}></div>
                                        </div>
                                    </CardContent>
                                    <CardActions style={{ justifyContent: 'space-between' }}>
                                        <Button variant="contained" color="primary">Edit</Button>
                                        <Button variant="contained" color="secondary">Change Password</Button>
                                    </CardActions>
                                </div>
                                    : <div style={{ textAlign: "center", padding: '50px' }}>
                                        <CircularProgress color="secondary" className="loadingCircle" />
                                    </div>
                                }
                            </Card>
                        </div>

                        <div>
                            <h2 className="userCard">Client Info</h2>
                            <Card className="cardStyle">
                                {this.state.ClientInfo ? <div>
                                    <CardContent>
                                        <div>
                                            <div>Client: <b className='bolder'>{this.state.ClientInfo[0].ClientName}</b></div>
                                            <div>Address: <b className='bolder'>{this.state.ClientInfo[0].AddressLine1}</b></div>
                                            <div><span style={{ margin: "0px 35px" }}></span><b className='bolder'>{this.state.ClientInfo[0].City}, {this.state.ClientInfo[0].StateCode} {this.state.ClientInfo[0].ZipCode}</b></div>
                                            <div>Contact: <b className='bolder'>{this.state.ClientInfo[0].ClientContactFirstName} {this.state.ClientInfo[0].ClientContactLastName}</b></div>
                                            <div>Contact Email: <b className='bolder'>{this.state.ClientInfo[0].ClientContactEmailAddress}</b></div>
                                            <div>Plan: <b className='bolder'>{PlanLookup[this.state.ClientInfo[0].ClientPlanID].title}</b></div>
                                            <div>Description: <b className='bolder'>{PlanLookup[this.state.ClientInfo[0].ClientPlanID].Description}</b></div>
                                        </div>
                                    </CardContent>
                                    <CardActions style={{ justifyContent: 'space-between' }}>
                                        <Button variant="contained" color="primary">Edit</Button>
                                        <Button variant="contained" color="secondary">Change Plan</Button>
                                    </CardActions>
                                </div>
                                    : <div style={{ textAlign: "center", padding: '50px' }}>
                                        <CircularProgress color="secondary" className="loadingCircle" />
                                    </div>
                                }
                            </Card>
                        </div>
                    </div>

                    {!this.state.InvitingUser && <div style={{ textAlign: 'center' }}>
                        <Button variant="contained" style={{ width: '42%' }} color="primary" onClick={() => this.setState({ InvitingUser: true })}>Invite User</Button>
                    </div>}

                    {this.state.InvitingUser &&
                        <div>
                            <h2 className="userCard">Invite User</h2>
                            <Card className="cardStyle">
                                {this.state.ClientInfo ? <div>
                                    <CardContent>
                                        <form>
                                            <div>
                                                <TextField
                                                    label='First Name'
                                                    className="without-padding"
                                                    name='first'
                                                    variant="outlined"
                                                    onChange={(e) => this.changeValue(e)}
                                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                                    required={true}
                                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                                />
                                            </div>
                                            <div>
                                                <TextField
                                                    label='Last Name'
                                                    className="without-padding"
                                                    name='last'
                                                    variant="outlined"
                                                    onChange={(e) => this.changeValue(e)}
                                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                                    required={true}
                                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                                />
                                            </div>
                                            <div>
                                                <TextField
                                                    label='Email'
                                                    className="without-padding"
                                                    name='Email'
                                                    variant="outlined"
                                                    onChange={(e) => this.changeValue(e)}
                                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                                    required={true}
                                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                                />
                                            </div>
                                            <div>
                                                <TextField
                                                    id='Role'
                                                    select
                                                    label='Role'
                                                    variant='outlined'
                                                    name="RoleID"
                                                    required={true}
                                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                                    className="without-padding"
                                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                                    InputProps={{ style: { minWidth: '245px', marginBottom: '10px' } }}
                                                    SelectProps={{
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            },
                                                            getContentAnchorEl: null
                                                        }
                                                    }}
                                                    onChange={(e) => this.changeValue(e)}
                                                >
                                                    <MenuItem value={""} hidden></MenuItem>
                                                    <MenuItem value={1}>{'Admin'}</MenuItem>
                                                    <MenuItem value={2}>{"User"}</MenuItem>
                                                </TextField>
                                            </div>
                                            <div>
                                                <TextField
                                                    id='UserLevel'
                                                    select
                                                    name="UserLevel"
                                                    label='UserLevel'
                                                    variant='outlined'
                                                    required={true}
                                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                                    className="without-padding"
                                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                                    InputProps={{ style: { minWidth: '245px', marginBottom: '10px' } }}
                                                    SelectProps={{
                                                        MenuProps: {
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "left"
                                                            },
                                                            getContentAnchorEl: null
                                                        }
                                                    }}
                                                    onChange={(e) => this.changeValue(e)}
                                                >
                                                    <MenuItem value={""} hidden></MenuItem>
                                                    <MenuItem value={1}>{'Maintainer'}</MenuItem>
                                                    <MenuItem value={2}>{"Reader"}</MenuItem>
                                                </TextField>
                                            </div>
                                        </form>
                                    </CardContent>
                                    <CardActions style={{ justifyContent: 'space-between' }}>
                                        <Button variant="contained" color="primary" onClick={() => this.submitForm(this.state)}>Submit</Button>
                                        <Button variant="contained" color="secondary" onClick={() => this.setState({ InvitingUser: true })}>Canel</Button>
                                    </CardActions>
                                </div>
                                    : <div style={{ textAlign: "center", padding: '50px' }}>
                                        <CircularProgress color="secondary" className="loadingCircle" />
                                    </div>
                                }
                            </Card>
                        </div>
                    }

                    <div>
                        <h2 className="userTable">Users</h2>
                    </div>

                    <TableContainer component={Paper} className="tableShadow" style={{ marginRight: 'auto', marginLeft: 'auto' }}>
                        {this.state.people.length !== 0 ? <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>First</TableCell>
                                    <TableCell >Last</TableCell>
                                    <TableCell >Email</TableCell>
                                    <TableCell >RoleID</TableCell>
                                    <TableCell >User Level</TableCell>
                                    <TableCell >Status</TableCell>
                                    <TableCell >Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.people.map((row) => (
                                    <TableRow key={row.LoginID}>
                                        <TableCell component="th" scope="row">
                                            {row.FirstName}
                                        </TableCell>
                                        <TableCell >{row.LastName}</TableCell>
                                        <TableCell >{row.LoginID}</TableCell>
                                        <TableCell >{row.RoleID}</TableCell>
                                        <TableCell >{row.UserLevel}</TableCell>
                                        <TableCell >{row.IsActive ? "Active" : "Not Registered"}</TableCell>
                                        <TableCell >
                                            {row.IsActive ?
                                                <Button variant="contained" color="secondary">
                                                    Deactivate
                                                </Button>
                                                : <Button variant="contained" color="primary">
                                                    Resend Invite
                                                </Button>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                            : <div style={{ textAlign: "center", padding: '50px' }}>
                                <CircularProgress color="secondary" className="loadingCircle" />
                            </div>
                        }
                    </TableContainer>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/user/account.js